import { createFileRoute } from '@tanstack/react-router';

import { Route as NewRoute } from 'routes/_private/_route/_internal/people/$identityId/index.route';

/** Forwards to `/people/:identityId` (see the parent route). */
export const Route = createFileRoute(
  '/_private/_route/_internal/candidates/$candidateId/',
)({
  validateSearch: NewRoute.options.validateSearch,
});
